import * as z from 'zod';

export type UnitFormSchemaValues = z.infer<typeof unitFormSchema>;
export const unitFormSchema = z.object({
    name: z.string().max(64).nonempty(),
    code: z.string().max(16).nonempty(),
    abbreviation: z.string().max(16).nonempty(),
});
